var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.licenza || _vm.licenza > -1)?_c('v-card',{staticClass:"hide-cloak mb-5",class:_vm.classLicenza,attrs:{"color":"error","dark":""}},[_c('v-card-title',[_vm._v("Licenza scaduta")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }